<template v-if="notEmpty(odata) && ('selectedCity' in odata) && notEmpty(flightSummary) && flightSummary">
    <div class="totalbox">
        <div class="titbox">Flight Information</div>
        <template v-for="(item, idx) in flightSummary">
            <div class="listbox">
                <div class="tit">
                    {{ idx ? 'Return' : 'Depart' }}</div>
                <div class="row">
                    <p class="label">
                        <img :src="'/images/flight/' + (idx ? 'airub' : 'airup') + '.png'" class="airico" alt="">
                    </p>
                    <p class="contxt">
                        {{ idx ? returncity : departcity }} - {{ idx ? departcity : arrivalcity }}
                    </p>
                </div>
                <div class="row">
                    <p class="label">Departure</p>
                    <p class="contxt">{{ flyWeekMDate(item.depart_date) }}</p>
                </div>
                <div class="row">
                    <p class="label">Arrival</p>
                    <p class="contxt">{{ flyWeekMDate(item.arrival_date) }}</p>
                </div>
                <div class="row">
                    <p class="label">Stops</p>
                    <p class="contxt stop-summary">
                        <span v-if="hasOvernightWarning(item)" class="overnight-warning">
                            <img src="/images/flight/icon_error.png" class="overnight-warning-icon" alt="">
                            Overnight
                        </span>
                        <span>{{ getStopText(item.stop) }}</span>
                    </p>
                </div>
                <div class="row">
                    <p class="label">Baggages</p>
                    <p class="contxt">
                    <div>
                        {{ (item.checked_baggage > 0) ? item.checked_baggage + ' free checked luggage' : 'No checked luggage' }}
                        <template v-if="item.carry_on_baggage > 0">
                            <br>{{ item.carry_on_baggage }} carry-on luggage
                        </template>
                    </div>
                    </p>
                </div>
            </div>
            <hr v-if="idx == 0" class="fenge">
        </template>
        <div class="listbox ticket-price-box" v-if="!isFPTrip">
            <div class="row total">
                <p class="label">Ticket Price</p>
                <p class="contxt">{{ priceFormat(odata.currency,(parseFloat(odata.cityprice) + ((notEmpty(odata.flightOffer) && notEmpty(odata.flightOffer.price))?parseFloat(odata.flightOffer.price):0)) * parseInt(persons),',',2,1) }}</p>
            </div>
        </div>
        <div class="listbox flight-policy-box">
            <div class="tipstxt">
                <p><span @click="airfareEvent()">Click<img src="/images/flight/icon_tipinfo.png" class="ico"
                            style="width: 1.6rem;height: 100%;position: relative;" alt=""
                            ></span>to
                    check the flight policy
                </p>
            </div>
        </div>
    </div>
    <div class="prop" v-if="airfaretips" @click="airfaretips = false">
        <div class="con airfaretipscon" v-if="Announcements.length > 0" @click.stop>
            <div class="closer fixed_closer" @click="airfaretips = false"><img src="/images/icon_close.png" /></div>
        
        <div class="pop_con">
            <div class="product_policy_title">Operator Policy-Flight Portion</div>
            <!-- <p v-if="outDays(120)">
                Your refundable air deposit is {{ flight_deposit > 0?priceFormat(odata.currency, flight_deposit/persons, ',', 2,1):'$0' }}, 
                and the full ticket price is {{ priceFormat(odata.currency,parseFloat(odata.flights_amount)/persons, ',', 2,1) }} per person
            </p> 
            <p v-else>    
                Your air deposit is {{ priceFormat(odata.currency,odata.flights_amount/persons, ',', 2,1) }} per person
            </p>-->
            <p v-for="(ann, idx) in displayAnnouncements" :key="idx">
                {{ ann }}
            </p>
        </div>  </div>
    </div>
</template>
<script>

import { notEmpty, priceFormat } from "@/utils/tool.js";
import { localDriver } from '@/utils/localDriver'
import { isOvernightLayover } from '@/utils/flightLayoverRules'

export default {
    props: ['flightSummary','rmkey','odkey','refidx'],
    components: {
    },
    data() {
        return {
            priceFormat,
            odata: {},
            isCollapse: false,
            departcity: '',
            arrivalcity: '',
            returncity: '',
            airfaretips: false,
            Announcements: [],
            flight_deposit: 0,
            persons: 1,
            isFPTrip:false,
            memberType: 0,
            membershipRuleFetchStatus: 0,
        };
    },
    computed: {
        displayAnnouncements() {
            if (!Array.isArray(this.Announcements)) {
                return [];
            }
            if (!this.shouldApplyMembershipRefundWording) {
                return this.Announcements;
            }
            const memberType = this.resolveMemberType();
            const explicitWord = String(this.odata?.membership_refund_deposit_word ?? '').trim().toLowerCase();
            const depositWord = memberType === 1 || memberType === 10
                ? ((explicitWord === 'non-refundable' || explicitWord === 'refundable') ? explicitWord : 'non-refundable')
                : (memberType >= 2 ? 'refundable' : '');
            if (!depositWord) {
                return this.Announcements;
            }
            return this.Announcements.map((line) => {
                const content = String(line ?? '');
                if (!/your\s+(?:non-refundable|refundable)\s+air deposit is/i.test(content)) {
                    return content;
                }
                return content.replace(/(your\s+)(?:non-refundable|refundable)(\s+air deposit is)/i, `$1${depositWord}$2`);
            });
        },
        shouldApplyMembershipRefundWording() {
            const memberType = this.resolveMemberType();
            const candidates = this.refundTermCandidates;
            const hasMembershipRule = candidates.some((source) => this.isMembershipRefundSourceEnabled(source));
            const hasAnnouncement = this.hasAirDepositAnnouncement;
            return memberType > 0 && hasMembershipRule && hasAnnouncement;
        },
        hasAirDepositAnnouncement() {
            if (!Array.isArray(this.Announcements)) return false;
            return this.Announcements.some((line) =>
                /your\s+(?:non-refundable|refundable)\s+air deposit is/i.test(String(line ?? ''))
            );
        },
        hasMembershipRefundTerm() {
            return this.refundTermCandidates.some((source) => this.isMembershipRefundSourceEnabled(source));
        },
        refundTermCandidates() {
            const o = this.odata || {};
            return [
                o?.flightOffer?.info?.refund_term,
                o?.flightOffer?.info?.refund_terms,
                o?.flightOffer?.info?.refundTerm,
                o?.flightOffer?.info?.refundTerms,
                o?.flightOffer?.info?.rule_id,
                o?.flightOffer?.info?.ruleId,
                o?.flightOffer?.refund_term,
                o?.flightOffer?.refund_terms,
                o?.flightOffer?.refundTerm,
                o?.flightOffer?.refundTerms,
                o?.flightOffer?.rule_id,
                o?.flightOffer?.ruleId,
                o?.tripFlightInfo?.refund_term,
                o?.tripFlightInfo?.refund_terms,
                o?.tripFlightInfo?.refundTerm,
                o?.tripFlightInfo?.refundTerms,
                o?.tripFlightInfo?.rule_id,
                o?.tripFlightInfo?.ruleId,
                o?.product_info?.refund_term,
                o?.product_info?.refund_terms,
                o?.product_info?.refundTerm,
                o?.product_info?.refundTerms,
                o?.product_info?.rule_id,
                o?.product_info?.ruleId,
                o?.refund_term,
                o?.refund_terms,
                o?.refundTerm,
                o?.refundTerms,
                o?.rule_id,
                o?.ruleId,
                o?.membership_refund_rule_applied,
                o?.membershipRefundRuleApplied,
            ];
        },
    },
    watch: {
        refidx: {
            async handler(newValue, oldValue) {

                await this.initData()
            },
        },    
    },
    mounted() {
        if (document.documentElement.clientWidth < 750) {
            this.ismobile = true
        } else {
            this.ismobile = false
        }
        //console.log('------------suuuuuu----', this.flightSummary);
        this.initData();
    },
    methods: {
        hasOvernightWarning(item) {
            if (item?.overnight_layover || item?.has_overnight_layover || item?.overnightLayover) {
                return true;
            }
            const segments = item?.segments;
            if (!segments || segments.length < 2) return false;
            for (let i = 0; i < segments.length - 1; i++) {
                const arrivalAt = segments[i]?.arrival?.at;
                const departureAt = segments[i + 1]?.departure?.at;
                if (!arrivalAt || !departureAt) continue;
                if (isOvernightLayover(arrivalAt, departureAt).isOvernight) {
                    return true;
                }
            }
            return false;
        },
        parseMemberTypeValue(raw) {
            if (raw == null) return 0;
            if (typeof raw === 'number' && Number.isFinite(raw)) return raw;
            if (Array.isArray(raw)) {
                for (const item of raw) {
                    const parsed = this.parseMemberTypeValue(item);
                    if (parsed > 0) return parsed;
                }
                return 0;
            }
            if (typeof raw === 'object') {
                const nested = [
                    raw?.membershiptype_id,
                    raw?.member_type,
                    raw?.type_id,
                    raw?.membershipType,
                    raw?.mmshiptypeid,
                    raw?.name,
                    raw?.title,
                    raw?.label,
                    raw?.text,
                ];
                for (const item of nested) {
                    const parsed = this.parseMemberTypeValue(item);
                    if (parsed > 0) return parsed;
                }
                return 0;
            }
            let text = '';
            try {
                text = String(raw).trim().toLowerCase();
            } catch (e) {
                return 0;
            }
            if (!text) return 0;
            if (text.includes('inside')) return 1;
            if (text.includes('insider')) return 1;
            if (text.includes('pathfinder')) return 10;
            if (text.includes('voyager')) return 2;
            if (text.includes('adventurer')) return 3;
            if (text.includes('elite')) return 4;
            const n = parseInt(text, 10);
            return Number.isFinite(n) ? n : 0;
        },
        isMembershipRefundSourceEnabled(source) {
            if (source == null) return false;
            if (typeof source === 'number') return source > 0;
            if (typeof source === 'string') {
                const text = source.trim();
                if (!text) return false;
                if (/^-?\d+(\.\d+)?$/.test(text)) return Number(text) > 0;
                if (text === '[]' || text === '{}') return false;
                return true;
            }
            if (Array.isArray(source)) return source.some((item) => this.isMembershipRefundSourceEnabled(item));
            if (typeof source === 'object') {
                const values = Object.values(source);
                if (values.length === 0) return false;
                return values.some((item) => this.isMembershipRefundSourceEnabled(item));
            }
            return false;
        },
        resolveMemberType() {
            return this.parseMemberTypeValue(this.memberType);
        },
        async loadMembershipRefundRuleMeta() {
            if (!this.odata?.product_id) {
                return;
            }
            if (this.membershipRuleFetchStatus === 1) {
                return;
            }
            this.membershipRuleFetchStatus = 1;
            try {
                const apiBase = String(import.meta.env.VITE_API_URL ?? '').trim();
                const url = apiBase.includes('?route=')
                    ? `${apiBase}product/product/trip_refund_rule`
                    : `${apiBase}?route=product/product/trip_refund_rule`;
                const reqPayload = {
                    product_id: String(this.odata.product_id),
                    depart_date: String(this.odata?.depart_date ?? ''),
                    trip_type: String(this.odata?.trip_type ?? ''),
                    member_type: String(this.memberType ?? 0),
                };
                const body = new URLSearchParams(reqPayload);
                const response = await fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                    body: body.toString(),
                    credentials: 'include',
                });
                const res = await response.json();
                const list = Array.isArray(res?.data) ? res.data : [];
                const hasRule = list.length > 0;
                const text = list
                    .map((item) => `${item?.inv ?? ''} ${item?.name ?? ''} ${item?.comment ?? ''}`)
                    .join(' ')
                    .toLowerCase();
                const insiderWord = /non[-\s]?refundable|not\s+refundable/.test(text)
                    ? 'non-refundable'
                    : 'refundable';
                // Re-read before writing: this.odata was snapshotted before the fetch above, which
                // can take long enough for the user to select a flight in the meantime. Spreading
                // the stale snapshot back would silently erase that flightOffer from storage.
                const freshOdata = await localDriver.getItem(this.odkey);
                this.odata = {
                    ...(freshOdata ?? this.odata),
                    membership_refund_rule_applied: hasRule ? 1 : 0,
                    membership_refund_deposit_word: insiderWord,
                };
                await localDriver.setItem(this.odkey, this.odata);
            } catch (e) {
            }
            this.membershipRuleFetchStatus = 2;
        },
        airfareEvent(){
            if(notEmpty(this.Announcements)){
                this.airfaretips = true;
            }      
        },
        outDays(days){
           return days != 0 && (new Date().nextDate(days).getFullstring().slice(0, 10) < this.odata.depart_date);
        },
        getStopText(stop) {
            if (0 == stop) {
                return 'Direct'
            }
            else if (1 == stop) {
                return '1 stop'
            }
            else {
                return 'Pending'
            }
        },
        flyWeekMDate(d, y = 1) {
            var dt = new Date((notEmpty(d) ? d.slice(0, 10) : d) + 'T00:00:01');
            var weeks = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
            var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            var formattedDate = weeks[dt.getDay()] + ", " + months[dt.getMonth()] + " " + dt.getDate() + ',' + (y > 0 ? ' ' + dt
                .getFullYear() : '');
            return formattedDate;
        },
        notEmpty(obj) {
            return notEmpty(obj);
        },
        async initData() {
            this.odata =  await localDriver.getItem(this.odkey)
            const customerInfo = await localDriver.getItem('customerInfo')
            this.memberType = this.parseMemberTypeValue(
                customerInfo?.member_type
                ?? customerInfo?.memberType
                ?? customerInfo?.mmshipHistory?.[0]?.mmshiptypeid
                ?? customerInfo?.mmshipHistory?.[0]?.description
                ?? customerInfo?.mmshipHistory?.[0]?.name
                ?? customerInfo?.membership
            )
            await this.loadMembershipRefundRuleMeta()
            //console.log('--------------init-------------------tBA---', { ...this.odata })

            this.isFPTrip = (this.odata.product_info.model.toUpperCase().slice(0, 3) === 'FP-');
            if (this.odata) {
                this.Announcements = this.odata?.flightOffer?.Announcements??(this.odata?.flightSummary?.[0]?.announcements??[]);
                if ('selectedCity' in this.odata) {
                    this.departcity = this.odata.selectedCity.spot + (this.odata.selectedCity.airport ? ' (' + this.odata.selectedCity.airport + ')' : '');
                }
                if ('alldays' in this.odata) {
                    let last = this.odata.alldays.length - 1;
                    this.arrivalcity = this.odata.alldays[0] ? (this.odata.alldays[0].cityname + (this.odata.alldays[0].airport ? ' (' + this.odata.alldays[0].airport + ')' : '')) : '';
                    this.returncity = this.odata.alldays[last] ? (this.odata.alldays[last].cityname + (this.odata.alldays[last].airport ? ' (' + this.odata.alldays[last].airport + ')' : '')) : '';
                }
                let rmlist = await localDriver.getItem(this.rmkey)
                let persons = 0;
                for (let i in rmlist) {
                    persons += (parseInt(rmlist[i].Adults) + parseInt(rmlist[i].Child));
                }
                this.persons = persons?persons:1;
                this.flight_deposit = parseFloat((notEmpty(this.odata.flightOffer) && notEmpty(this.odata.flightOffer.deposit)
                    && this.odata.flightOffer.deposit > 0) ? this.odata.flightOffer.deposit : 0 );   ///this.odata.flights_amount);
            }
        },
    }
};
</script>


<style scoped>
.pop_con {
  margin-top: 3rem;
 
  overflow-y: auto;
  height: 90%;
}
.product_policy_title {
    font-weight: bold;
    text-align: center;
    margin-bottom: 2rem;

}

.flightbox {
    background: #FFFFFF;
    border-radius: 1.2rem;
    padding: 1.8rem 2.4rem 2rem;
    margin-top: 1.6rem;
}

.flightbox .omitbox .infobox .airplay {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-family: Poppins;
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2.0rem;
    color: #333;
    margin-bottom: 1.4rem;
}

.flightbox .omitbox .infobox .airplay span:last-child {
    color: #999;
}

.flightbox .omitbox .infobox .airplay .airico {
    width: 2.4rem;
    margin-right: 1.2rem;
}

.flightbox .omitbox .infobox .process {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.flightbox .omitbox .infobox .process .info {
    width: 25%;
    color: #333;
}

.flightbox .omitbox .infobox .process .info:last-child {
    text-align: right;
}

.flightbox .omitbox .infobox .process .info .timebox {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    font-family: Poppins-Bold;
    font-weight: 700;
    position: relative;
}

.flightbox .omitbox .infobox .process .info:last-child .timebox {
    justify-content: flex-end;
}

.flightbox .omitbox .infobox .process .info .timebox .time {
    font-size: 2.0rem;
    line-height: 2.8rem;
    display: block;
}

.flightbox .omitbox .infobox .process .info .timebox .date {
    font-size: 1.4rem;
    line-height: 2.2rem;
    margin-left: 0.6rem;
}

.flightbox .omitbox .infobox .process .info .timebox .date i {
    color: #666;
    font-family: Poppins;
    font-size: 1.2rem;
    font-weight: 500;
    line-height: 1.6rem;
    text-align: right;
    position: absolute;
    right: 0;
    top: -1em;
}

.flightbox .omitbox .infobox .process .info .city {
    margin-top: 0.6rem;
    font-size: 1.4rem;
    line-height: 2.0rem;
}

.flightbox .omitbox .infobox .process .linebox {
    width: 45%;
}

.flightbox .omitbox .infobox .process .upbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 5% 0.7rem;
    margin-bottom: 0.5rem;
    border-bottom: 1px dashed #4F6F52;
}

.flightbox .omitbox .infobox .process .upbox .ico {
    width: 1.6rem;
}

.flightbox .omitbox .infobox .process .txt {
    color: #666;
    font-family: Poppins;
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2.0rem;
    text-align: center;

}

.flightbox .omitbox .btnbox {
    width: 17.6rem;
    text-align: center;
    font-family: Poppins-Bold;
    font-size: 1.4rem;
    font-weight: 700;
    line-height: 3.6rem;
}

.flightbox .omitbox .btnbox .pricebtn {
    border: 1px solid #4F6F52;
    border-radius: 0.8rem;
    color: #4F6F52;
    cursor: pointer;
}

.flightbox .omitbox .btnbox .showbtn {
    border: 1px solid #333;
    border-radius: 0.8rem;
    color: #333;
    margin-top: 0.8rem;
    cursor: pointer;
}

.flightbox .omitbox .btnbox .selectbtn {
    background: #00F1BD;
    border: 1px solid #00F1BD;
    color: #333 !important;
    border-radius: 0.8rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}

.flightbox .omitbox .btnbox .selectbtn .ico {
    width: 2rem;
    display: block;
    margin-right: 1rem;
}

.flightbox .omitbox .btnbox .packetinfo .li {
    margin-top: 0.8rem;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    color: #333;
    font-family: Poppins;
    font-size: 1.2rem;
    font-weight: 400;
    line-height: 1.4rem;
    text-align: left;
}

.flightbox .omitbox .btnbox .packetinfo .li .covicon {
    width: 2.4rem;
    margin-right: 0.8rem;
}

.flightbox .detail {
    background: #FAFAFA;
    border-radius: 1.2rem;
    padding: 2rem 2.4rem;
    margin-top: 2rem;
}

.flightbox .detail .tit {
    font-family: Poppins-Bold;
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 2.8rem;
    color: #071525;
    margin: 3.2rem 0 0.8rem;
}

.flightbox .detail .tit:first-child {
    margin-top: 0;
}

.flightbox .detail .tbaprocessbox {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
}

.flightbox .detail .processbox {
    margin: 0.8rem 0;
    padding: 0.1rem 0 0;
    border-left: 1px solid #CCCCCC;
    width: 40%;
}

.flightbox .detail .processbox .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1.2rem;
    position: relative;
}

.flightbox .detail .processbox .row::before {
    content: '';
    position: absolute;
    top: calc(100% - 0.2rem);
    left: 8.5rem;
    border-left: 1px solid #4F6F52;
    width: 0;
    height: 1.6rem;
    display: block;
}

.flightbox .detail .processbox .row.dao::before {
    display: none;
}

.flightbox .detail .processbox .row .left {
    width: 6rem;
    margin-right: 1rem;
    text-align: right;
}

.flightbox .detail .processbox .row .right {
    width: calc(100% - 11rem);
    text-align: left;
    margin-left: 1rem;
}

.flightbox .detail .processbox .row .coverbox {
    height: 4rem;
}

.flightbox .detail .processbox .row .dian {
    background: #4F6F52;
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
}

.flightbox .detail .processbox .row .ico {
    width: 1.6rem;
    display: block;
}

.flightbox .detail .processbox .row .time {
    font-family: Poppins-Bold;
    font-weight: 700;
    font-size: 1.6rem;
    line-height: 2.2rem;
    color: #333;
    margin-left: 1rem;
    display: block;
}

.flightbox .detail .errinfotxt {
    width: 55%;
    color: #333;
    font-family: Poppins;
    font-size: 1.2rem;
    font-weight: 400;
    line-height: 1.6rem;
    margin: 2rem 0;
}

.flightbox .detail .errinfotxt p {
    padding-left: 3.6rem;
    position: relative;
    margin-bottom: 1rem;
}

.flightbox .detail .errinfotxt .ico {
    width: 2.4rem;
    position: absolute;
    top: 0;
    left: 0;
}

.detail .tipstxt {
    font-family: Poppins;
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2.0rem;
    color: #333;
}

.totalbox .listbox.ticket-price-box {
    border-bottom: 0;
}

.totalbox .listbox.flight-policy-box {
    border-top: 1px solid #EAEAEA;
}

.totalbox .listbox .row .contxt.stop-summary {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.8rem;
    flex-wrap: wrap;
    text-align: right;
}

.overnight-warning {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    color: #F04F4F;
    font-family: Poppins-Bold;
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 1.6rem;
}

.overnight-warning-icon {
    width: 1.6rem;
    height: 1.6rem;
    display: block;
}

.totalbox .tipstxt {
    padding: 0.4rem 0 0.2rem;
}

.totalbox .tipstxt span {
    color: #1B80DE;
    cursor: pointer;
}

.totalbox .tipstxt .ico {
    cursor: pointer;
    width: 2rem;
    display: inline-block;
    margin-bottom: -0.5rem;
}

.airfaretipscon {
    padding: 2.4rem;
    font-family: Poppins;
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 2.4rem;
    text-align: left;
    color: #333;
}

.airfaretipscon p {
    padding-left: 2.4rem;
    position: relative;
}

.airfaretipscon p::before {
    content: '';
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    background: #333;
    position: absolute;
    top: 1rem;
    left: 1rem;
}

@media screen and (max-width:750px) {
    .prop {
        z-index: 999999;
    }

    .prop .con {
        position: absolute;
        box-sizing: border-box;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        border-radius: 2rem;
        box-shadow: 0px 10px 60px -10px #00000014;
        height: 90%;
        /* 保证上下各留5%空间 */
        overflow: auto;
        /* 内容溢出时出现滚动条 */
        width: 90% !important;
    }
    .prop .con .fixed_closer {

top: 0.0rem!important;

}
    .flightbox {
        padding: 1.2rem 1.6rem 1.6rem;
    }

    .flightbox .omitbox {
        display: block;
    }

    .flightbox .omitbox .infobox {
        width: calc(100%);
        padding-right: 0;
        border-right: 0;
    }

    .flightbox .omitbox .infobox .airplay i {
        display: none;
    }

    .flightbox .omitbox .infobox .airplay span {
        display: block;
    }

    .flightbox .omitbox .btnbox {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row-reverse;
        margin-top: 1.6rem;
    }

    .flightbox .omitbox .btnbox .selectbtn {
        width: 48%;
        margin-top: 0;
        border-radius: 0.8rem;
    }

    .flightbox .omitbox .infobox .process .info {
        width: 30%;
    }

    .flightbox .omitbox .infobox .process .info .timebox {
        display: block;
    }

    .flightbox .omitbox .infobox .process .info .city,
    .flightbox .omitbox .infobox .process .info .timebox .date {
        margin: 0;
        line-height: 2rem;
    }

    .flightbox .omitbox .infobox .process .linebox {
        width: 40%;
    }

    .flightbox .omitbox .infobox .process .upbox {
        padding: 0 0 0.7rem;
    }

    .flightbox .detail {
        padding: 0.8rem 1.2rem 1.2rem;
        margin-top: 1.6rem;
    }

    .flightbox .fenge {
        margin: 1.6rem 0;
    }

    .flightbox .detail .tit {
        margin: 2.4rem 0 0.8rem;
    }

    .flightbox .detail .processbox .layover {
        width: calc(22.4rem);
    }

    .flightbox .detail .processbox .row {
        align-items: flex-start;
    }

    .flightbox .detail .processbox .row::before {
        left: 11.1rem;
        height: calc(100% - 1.6rem);
        top: 2.6rem;
    }

    .flightbox .detail .processbox .row .left {
        width: 9.2rem;
    }

    .flightbox .detail .processbox .row .right {
        width: calc(100% - 13rem);
        text-align: left;
    }

    .flightbox .detail .processbox .row .coverbox .airplay {
        margin-right: 0;
        padding: 0.8rem 1rem;
        align-items: flex-start;
    }

    .flightbox .detail .processbox .row .coverbox .airplay .airico {
        width: 1.8rem;
        margin-right: 1rem;
        display: block;
    }

    .flightbox .detail .processbox .row .coverbox .covicon {
        margin-top: 0.8rem;
    }

    .flightbox .detail .processbox .row .ico {
        margin-top: 0.3rem;
    }

    .flightbox .detail .processbox .row .dian {
        margin-top: 0.6rem;
    }
}
</style>
